import axios from "axios";
import { apiKey } from "../config/config";
import React, { useEffect, useState, useRef } from "react";
import Table from "../components/Table";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TextComponent from "../components/TextComponent";

function ContractDescriptionTemplates({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;

  const [templates, setTemplates] = useState([]);
  const [description, setDescription] = useState("");
  const [editId, setEditId] = useState(null);
  const formRef = useRef(null);

  const fetchAll = async () => {
    try {
      const res = await axios.get(apiKey + "/description-templates", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTemplates(res.data.data || []);
    } catch (err) {
      console.error(err);
      toast.error("Error loading data");
    }
  };

  useEffect(() => {
    if (token) fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const handleSubmit = async () => {
    if (!description.trim()) return toast.error("Please enter a description");

    try {
      const payload = {
        description: description,
      };

      if (editId) {
        const res = await axios.put(apiKey + "/description-templates/" + editId, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        toast.success(res.data.Message || "Description template updated");
      } else {
        const res = await axios.post(apiKey + "/description-templates", payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        toast.success(res.data.Message || "Description template added");
      }

      setDescription("");
      setEditId(null);

      fetchAll();
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.Error || "Some error occured");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm(lang.Confirm_Delete || "Are you sure you want to delete this template?")) {
      try {
        await axios.delete(apiKey + `/description-templates/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        toast.success(lang.Deleted_Successfully || "Deleted successfully");
        fetchAll();
      } catch (err) {
        console.error(err);
        toast.error("Error deleting template");
      }
    }
  };

  const columns = [
    { 
      header: "SN", 
      cell: (row) => row.row.index + 1 
    },
    { 
      header: lang.Description || "Description", 
      accessorKey: "description",
      cell: row => <TextComponent text={row.getValue()} />
    },
    {
      header: lang.Actions || "Actions",
      cell: (row) => (
        <div className="dropdown top-0 start-0">
          <button
            className="btn btn-primary dropdown-toggle"
            type="button"
            id={`dropdownMenuButton-${row.row.original.id}`}
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {lang.Actions || "Actions"}
          </button>
          <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton-${row.row.original.id}`}>
            <li>
              <button
                type="button"
                onClick={() => {
                  setEditId(row.row.original.id);
                  setDescription(row.row.original.description);
                  formRef.current?.scrollIntoView({ behavior: "smooth" });
                }}
                className="dropdown-item mt-0"
              >
                {lang.Edit || "Edit"}
              </button>
            </li>
            <li>
              <button
                type="button"
                onClick={() => handleDelete(row.row.original.id)}
                className="dropdown-item mt-0 text-danger"
              >
                {lang.Delete_Text || "Delete"}
              </button>
            </li>
          </ul>
        </div>
      )
    }
  ];

  return (
    <div>
      <main className="main" id="main">
        <ToastContainer position="bottom-right" autoClose={5000} theme="colored" />

        <div className="pagetitle">
          <h1>{lang.General_Management || "General Management"}</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                  <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
                </svg>
              </li>
              <li className="breadcrumb-item">{lang.Contracts || "Contracts"}</li>
              <li className="breadcrumb-item active">{lang["Description Templates"] || "Description Templates"}</li>
            </ol>
          </nav>
        </div>

        {/* LIST */}
        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="row pt-3">
                  <div className="rr col-9">{lang["Description Templates"] || "Description Templates"}</div>
                </div>
                <div className="card-body">
                  <div className="mt-3 mb-3">
                    <Table
                      lang={lang}
                      data={templates}
                      columns={columns}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ADD */}
        <section className="section" ref={formRef}>
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex mt-3 mb-3">
                    <h4 className="headingh4 fw-bold">
                      {editId ? (lang.Edit_Template || "Edit Template") : (lang.Add_Template || "Add Template")}
                    </h4>
                  </div>

                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleSubmit();
                    }}
                  >
                    <div className="d-flex mt-3 mb-3 justify-content-end">
                      {editId && (
                        <button
                          type="button"
                          className="btn-cancel me-2"
                          onClick={() => {
                            setEditId(null);
                            setDescription("");
                          }}
                        >
                          {lang.Cancel || "Cancel"}
                        </button>
                      )}
                      <button type="submit" className="btn-save">
                        {editId ? (lang.Update || "Update") : (lang.Save_And_Publish || "Save & Publish")}
                      </button>
                    </div>

                    {/* Description */}
                    <div className="row mb-3 d-flex justify-content-center">
                      <div className="col-lg-8">
                        <label htmlFor="description" className="w-100">
                          <span style={{ fontSize: "14px" }}>
                            {lang.Description || "Description"}:
                          </span>
                          <textarea
                            id="description"
                            className="form-control"
                            placeholder={lang.Description || "Description"}
                            rows={5}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            required
                          />
                        </label>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default ContractDescriptionTemplates;
